import { Link } from "react-router-dom";
import { Facebook, Instagram, Heart } from "lucide-react";
import { useSite } from "../lib/store";

const Col = ({ title, children }) => (
  <div>
    <p className="font-display text-base mb-4">{title}</p>
    <ul className="space-y-2 text-sm text-[var(--muted)]">{children}</ul>
  </div>
);
const L = ({ to, children, testid }) => (
  <li><Link to={to} data-testid={testid} className="hover:text-[var(--pink)] transition-colors">{children}</Link></li>
);

export default function Footer() {
  const { site } = useSite();
  const c = site?.company || {};
  return (
    <footer className="mt-24 relative bg-[var(--blush)]" data-testid="site-footer">
      <svg viewBox="0 0 1440 60" className="absolute -top-[59px] left-0 w-full h-[60px]" preserveAspectRatio="none" aria-hidden>
        <path d="M0 40 C 240 0, 480 60, 720 30 S 1200 0, 1440 35 L1440 60 L0 60 Z" fill="var(--blush)" />
      </svg>
      <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <img src="/logo.png" alt="" className="h-20" />
          <p className="font-display text-base mt-3 text-[var(--pink-dark)]">{site?.texts?.footer_slogan}</p>
          <div className="flex gap-3 mt-4">
            {site?.social?.facebook && <a href={site.social.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="w-10 h-10 rounded-full bg-white grid place-items-center hover:-translate-y-1 transition-transform"><Facebook className="w-4 h-4" /></a>}
            {site?.social?.instagram && <a href={site.social.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="w-10 h-10 rounded-full bg-white grid place-items-center hover:-translate-y-1 transition-transform"><Instagram className="w-4 h-4" /></a>}
          </div>
        </div>
        <Col title="Nakupování">
          <L to="/eshop">E-shop</L>
          <L to="/kategorie/materialy-zdarma">Materiály zdarma</L>
          <L to="/darkove-poukazy">Dárkové poukazy</L>
          <L to="/jak-nakoupit">Jak nakoupit</L>
          <L to="/jak-to-funguje">Jak to funguje</L>
        </Col>
        <Col title="Informace">
          <L to="/o-nas">O nás</L>
          <L to="/obchodni-podminky">Obchodní podmínky</L>
          <L to="/gdpr">Ochrana osobních údajů</L>
          <L to="/cookies">Cookies</L>
          <L to="/reklamace">Reklamace</L>
          <li><button data-testid="footer-cookie-settings" onClick={() => window.dispatchEvent(new Event("mps-cookies"))} className="hover:text-[var(--pink)]">Nastavení cookies</button></li>
        </Col>
        <Col title="Kontakt">
          <L to="/kontakt" testid="footer-contact-link">Napište nám</L>
          <L to="/o-nas">Kdo za materiály stojí</L>
        </Col>
      </div>
      <div className="border-t border-[#f3dbe6]">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row gap-2 justify-between text-xs text-[var(--muted)]">
          <span className="flex items-center gap-1">© {new Date().getFullYear()} {c.name} · tvořeno s <Heart className="w-3 h-3 fill-[var(--pink)] text-[var(--pink)]" /> pro děti</span>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[var(--pink)]">Administrace</Link>
        </div>
      </div>
    </footer>
  );
}
